var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var FormError = /** @class */ (function (_super) {
    __extends(FormError, _super);
    function FormError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errors = [];
        return _this;
    }
    return FormError;
}(Error));
export { FormError };



// WEBPACK FOOTER //
// ./src/app/common-theme/models/form-error.model.ts.pre-build-optimizer.js